module.exports = __webpack_public_path__ + "img/roof-repair-exterior-maintenance-06-square.beb87f59.jpg";